import { Box } from "@mui/material";
import React, { useState } from "react";
import TransactionsTable from "./TransactionsTable";
import TransactionDetailsModal from "./TransactionDetailsModal";
import { PaginationProps, TransactionListProps } from "../../typings";

const columns = [
  { id: "id", label: "Transaction ID", minWidth: 100 },
  { id: "date", label: "Date", minWidth: 120 },
  { id: "from_account_name", label: "From", minWidth: 150 },
  { id: "to_account_name", label: "To", minWidth: 150 },
  {
    id: "scholarship_application_id",
    label: "Application ID",
    minWidth: 80,
    align: "center" as const,
  },
];

type TransactionsListProps = {
  transactions: TransactionListProps[];
  pagination: PaginationProps;
  onPageChange: (e: unknown, page: number) => void;
  onRowsPerPageChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onRefresh?: () => void;
};

const TransactionsList: React.FC<TransactionsListProps> = ({
  transactions,
  pagination,
  onPageChange,
  onRowsPerPageChange,
  onRefresh
}) => {
  const [selectedTransaction, setSelectedTransaction] = useState<TransactionListProps | null>(null);
  const [detailsModalOpen, setDetailsModalOpen] = useState(false);

  const handleViewDetails = async (transaction: TransactionListProps) => {
    setSelectedTransaction(transaction);
    setDetailsModalOpen(true);
  };

  const handleCloseDetailsModal = () => {
    setDetailsModalOpen(false);
    setSelectedTransaction(null);
  };
  
  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <TransactionsTable
        columns={columns}
        data={transactions}
        onView={handleViewDetails}
        pagination={pagination}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
      />
      
      {selectedTransaction && (
        <TransactionDetailsModal
          open={detailsModalOpen}
          onClose={handleCloseDetailsModal}
          transaction={selectedTransaction}
        />
      )}
    </Box>
  );
};

export default TransactionsList;
